const Card = require("../Dashboard/card");
const WithLoader = require("../Dashboard/with-loader");

const CardWithLoader = WithLoader(Card);

module.exports = CardWithLoader;



// WEBPACK FOOTER //
// ./app/screens/Dashboard/components/Dashboard/card-with-loader.jsx